// import { jsPDF } from "jspdf";
// import logoCCC from "../../assets/logoCCC.png";
// /**
//  * Generates a "Bon de Livraison" PDF for a given transaction.
//  * @param {Object} transaction - The transaction object from the API
//  * @param {string|null} logoBase64 - Optional base64 logo string (e.g. "data:image/png;base64,...")
//  */
// export const generateBL = (transaction, logoBase64 = null) => {
//   const doc = new jsPDF({ unit: "mm", format: "a4" });

//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();
//   const margin = 20;
//   const primaryColor = [13, 49, 97]; // Dark navy blue matching Cayon Cloud

//   // ── LOGO ────────────────────────────────────────────────────────────────────
//   doc.addImage(logoCCC, "PNG", margin, 10, 28, 28);

//   // ── TITLE ────────────────────────────────────────────────────────────────
//   doc.setFontSize(16);
//   doc.setTextColor(30, 30, 30);
//   doc.setFont("helvetica", "bold");
//   doc.text("Bon De Livraison", margin + 45, 28, { align: "left" });

//   // ── RECEIVER INFO BOX (top right) ────────────────────────────────────────
//   const boxX = pageWidth - margin - 65;
//   const boxY = 14;
//   const boxW = 65;
//   const boxH = 30;
//   doc.setDrawColor(180, 180, 180);
//   doc.setLineWidth(0.4);
//   doc.roundedRect(boxX, boxY, boxW, boxH, 3, 3);
//   doc.setFontSize(8);
//   doc.setTextColor(100, 100, 100);
//   doc.setFont("helvetica", "normal");
//   doc.text("Destinataire :", boxX + 3, boxY + 7);
//   doc.setTextColor(30, 30, 30);
//   doc.setFont("helvetica", "bold");
//   doc.text(transaction.receiver?.username || "N/A", boxX + 3, boxY + 14);

//   // ── DIVIDER ──────────────────────────────────────────────────────────────
//   doc.setDrawColor(220, 220, 220);
//   doc.setLineWidth(0.3);
//   doc.line(margin, 50, pageWidth - margin, 50);

//   // ── DATE ─────────────────────────────────────────────────────────────────
//   const dateStr = new Date(transaction.createdAt).toLocaleDateString("fr-FR");
//   doc.setFontSize(9);
//   doc.setTextColor(60, 60, 60);
//   doc.setFont("helvetica", "bold");
//   doc.text("Date", margin, 62);
//   doc.setFont("helvetica", "normal");
//   doc.setDrawColor(180, 180, 180);
//   doc.rect(margin, 65, 35, 8);
//   doc.setTextColor(30, 30, 30);
//   doc.text(dateStr, margin + 2, 70.5);

//   // ── TABLE ─────────────────────────────────────────────────────────────────
//   const tableTop = 85;
//   const colWidths = [45, 50, 50, 25]; // Désignation, Premier N°, Dernier N°, Quantité
//   const headers = ["Désignation", "Premier N° de série", "Dernier N° de série", "Quantité"];
//   const rowHeight = 9;

//   // Table header background
//   doc.setFillColor(...primaryColor);
//   doc.rect(margin, tableTop, colWidths.reduce((a, b) => a + b, 0), rowHeight, "F");

//   // Header text
//   doc.setFontSize(8.5);
//   doc.setTextColor(255, 255, 255);
//   doc.setFont("helvetica", "bold");
//   let xCursor = margin;
//   headers.forEach((h, i) => {
//     doc.text(h, xCursor + 3, tableTop + 6);
//     xCursor += colWidths[i];
//   });

//   // Row data
//   const rowY = tableTop + rowHeight;
//   doc.setFillColor(245, 247, 250);
//   doc.rect(margin, rowY, colWidths.reduce((a, b) => a + b, 0), rowHeight, "F");
//   doc.setDrawColor(220, 220, 220);
//   doc.rect(margin, rowY, colWidths.reduce((a, b) => a + b, 0), rowHeight);

//   const rowData = [
//     "Cartes SIM",
//     transaction.first_iccid || "N/A",
//     transaction.last_iccid || "N/A",
//     String(transaction.quantity ?? "N/A"),
//   ];

//   doc.setFontSize(8);
//   doc.setTextColor(30, 30, 30);
//   doc.setFont("helvetica", "normal");
//   xCursor = margin;
//   rowData.forEach((val, i) => {
//     doc.text(val, xCursor + 3, rowY + 6);
//     xCursor += colWidths[i];
//   });

//   // Column separators for header + row
//   xCursor = margin;
//   colWidths.forEach((w, i) => {
//     if (i < colWidths.length - 1) {
//       xCursor += w;
//       doc.setDrawColor(200, 200, 200);
//       doc.line(xCursor, tableTop, xCursor, rowY + rowHeight);
//     }
//   });

//   // ── SIGNATURE ────────────────────────────────────────────────────────────
//   const sigY = rowY + rowHeight + 30;
//   doc.setFontSize(9);
//   doc.setTextColor(80, 80, 80);
//   doc.setFont("helvetica", "normal");
//   doc.text("Signature et Cachet", pageWidth / 2 + 20, sigY, { align: "center" });

//   // ── FOOTER ───────────────────────────────────────────────────────────────
//   doc.setDrawColor(...primaryColor);
//   doc.setLineWidth(0.6);
//   doc.line(margin, pageHeight - 20, pageWidth - margin, pageHeight - 20);

//   doc.setFontSize(7.5);
//   doc.setTextColor(80, 80, 80);
//   doc.setFont("helvetica", "normal");
//   doc.text(
//     "© 2026 Cayon Cloud Communications - Tous droits réservés",
//     pageWidth / 2,
//     pageHeight - 14,
//     { align: "center" }
//   );
//   doc.text(
//     "1 Rue Mohieddine Kelibi / Manar 3",
//     pageWidth / 2,
//     pageHeight - 9,
//     { align: "center" }
//   );

//   // ── SAVE ─────────────────────────────────────────────────────────────────
//   const filename = `BL_${transaction._id}_${dateStr.replace(/\//g, "-")}.pdf`;
//   doc.save(filename);
// };
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import logoCCC from "../../assets/logoCCC.png";

/**
 * Generates a "Bon de Livraison" PDF for a given transaction.
 * @param {Object} transaction - The transaction object from the API
 */
export const generateBL = (transaction) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const dateStr = new Date(transaction.createdAt).toLocaleDateString("fr-FR");
  const img = new Image();
  img.src = logoCCC;

  img.onload = () => {
    // ── LOGO ──────────────────────────────────────────────────────────────────
    doc.addImage(img, "PNG", 20, 20, 36, 36);

    // ── TITLE ─────────────────────────────────────────────────────────────────
    doc.setFont("helvetica", "bold");
    doc.setFontSize(28);
    doc.text("Bon De Livraison", pageWidth / 2, 60, { align: "center" });

    // ── RECEIVER INFO BOX (top right) ─────────────────────────────────────────
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.roundedRect(140, 70, 60, 40, 2, 2, "S");
    doc.text("Destinataire :", 145, 78);
    doc.setFont("helvetica", "bold");
    doc.text(transaction.receiver?.username || "N/A", 145, 86);

    // ── DATE TABLE ────────────────────────────────────────────────────────────
    autoTable(doc, {
      head: [["Date"]],
      body: [[dateStr]],
      startY: 110,
      theme: "grid",
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
      },
      styles: {
        fontSize: 10,
        cellPadding: 2,
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 30 },
      },
    });

    // ── MAIN DATA TABLE ───────────────────────────────────────────────────────
    autoTable(doc, {
      startY: 140,
      head: [["Désignation", "Premier N° de série", "Dernier N° de série", "Quantité"]],
      body: [[
        "Cartes SIM",
        transaction.first_iccid || "N/A",
        transaction.last_iccid || "N/A",
        String(transaction.quantity ?? "N/A"),
      ]],
      theme: "grid",
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
      },
      styles: {
        fontSize: 10,
        cellPadding: 3,
        valign: "middle",
      },
    });

    // ── SIGNATURE ─────────────────────────────────────────────────────────────
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Signature et Cachet", 140, doc.lastAutoTable.finalY + 20);

    // ── FOOTER ────────────────────────────────────────────────────────────────
    const footerY = 270;
    doc.setDrawColor(25, 63, 120);
    doc.setLineWidth(0.2);
    doc.line(15, footerY + 2, pageWidth - 15, footerY + 2);
    doc.setFontSize(10);
    doc.text(
      "© 2026 Cayon Cloud Communications - Tous droits réservés",
      pageWidth / 2,
      footerY + 10,
      { align: "center" }
    );
    doc.text(
      "1 Rue Mohieddine Kelibi / Manar 3",
      pageWidth / 2,
      footerY + 16,
      { align: "center" }
    );

    // ── SAVE ──────────────────────────────────────────────────────────────────
    const filename = `BL_${transaction._id}_${dateStr.replace(/\//g, "-")}.pdf`;
    doc.save(filename);
  };
};